/*LIBRARY*/
import { useEffect, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const WAIT_INTERVAL = 1000;

// --- Black and White Inline Styles ---
const styles = {
  container: {
    backgroundColor: "#ffffff",
    color: "#000000",
    border: "1px solid #000000",
    padding: "12px",
    marginBottom: "12px",
    borderRadius: "2px",
  },
  textSmall: {
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "8px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  scaleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    marginTop: "0", // Changed from 8px to 0 to make it compact
    fontSize: "10px",
    lineHeight: "1",
    color: "#666666",
  },
  textInput: {
    width: "100%",
    padding: "6px",
    border: "1px solid #000000",
    backgroundColor: "#ffffff",
    color: "#000000",
    boxSizing: "border-box",
  },
  colorInputWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
  },
  colorInput: {
    border: "1px solid #000000",
    padding: "0",
    width: "30px",
    height: "30px",
    cursor: "pointer",
  },
  selectInput: {
    width: "100%",
    padding: "6px",
    border: "1px solid #000000",
    backgroundColor: "#ffffff",
    color: "#000000",
    cursor: "pointer",
  },
};

const DEFAULT_STYLE_EDITOR = ({
  auth,
  layer,
  properties,
  loading_reducer,
  set_value_properties,
  status_action,
}) => {
  const timer = useRef(null);

  useEffect(() => {
    timer.current = null;
  }, []);

  const on_change = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    const type = e.target.type;
    if (type === "range" || type === "number") {
      value = Number(value);
    }
    const { paint_object_edited } = properties;
    paint_object_edited[name] = value;
    let { style_parameter } = properties;
    set_value_properties({
      key: "paint_object_edited",
      value: paint_object_edited,
    });
    set_value_properties({
      key: "style_parameter",
      value: style_parameter,
    });
    timer.current = setTimeout(trigger_action, WAIT_INTERVAL);
  };

  const trigger_action = () => {
    status_action();
  };

  const render_scale = (min, max, step) => {
    const numbers_array = [];
    for (let i = min; i <= max; i += step) {
      let number = i;
      if (!Number.isInteger(i)) {
        number = i.toFixed(1);
      }
      numbers_array.push(number);
    }
    return (
      <div className="scale_range" style={styles.scaleContainer}>
        {numbers_array.map((number) => (
          <span key={number} className="scale_range_number">
            {number}
          </span>
        ))}
      </div>
    );
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { paint_object_edited, style_parameter } = properties;

  //content
  const paint_properties_object = {
    circle: [
      {
        name: dict?.["Circle opacity"]?.[language],
        key: "circle-opacity",
        type: "number",
        min: 0,
        max: 1,
        step: 0.01,
        step_visual: 0.2,
        is_limit: true,
      },
      {
        name: dict?.["Circle radius"]?.[language],
        key: "circle-radius",
        type: "number",
        min: 0,
        max: 100,
        step: 1,
        step_visual: 10,
        is_limit: false,
      },
      {
        name: dict?.["Circle stroke color"]?.[language],
        key: "circle-stroke-color",
        type: "color",
        is_limit: false,
      },
      {
        name: dict?.["Circle stroke width"]?.[language],
        key: "circle-stroke-width",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        step_visual: 1,
        is_limit: false,
      },
      {
        name: dict?.["Circle stroke opacity"]?.[language],
        key: "circle-stroke-opacity",
        type: "number",
        min: 0,
        max: 1,
        step: 0.01,
        step_visual: 0.2,
        is_limit: true,
      },
      {
        name: dict?.["Circle blur"]?.[language],
        key: "circle-blur",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        step_visual: 1,
        is_limit: false,
      },
    ],
    line: [
      {
        name: dict?.["Line width"]?.[language],
        key: "line-width",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        is_limit: false,
      },
      {
        name: dict?.["Line opacity"]?.[language],
        key: "line-opacity",
        type: "number",
        min: 0,
        max: 1,
        step: 0.01,
        step_visual: 0.2,
        is_limit: true,
      },
      {
        name: dict?.["Line gap width"]?.[language],
        key: "line-gap-width",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        is_limit: false,
      },
      {
        name: dict?.["Line blur"]?.[language],
        key: "line-blur",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        is_limit: false,
      },
      {
        name: dict?.["Line translate anchor"]?.[language],
        key: "line-translate-anchor",
        type: "options",
        options: [
          { name: "Map", value: "map" },
          { name: "Viewport", value: "viewport" },
        ],
        is_limit: false,
      },
    ],
    fill: [
      {
        name: dict?.["Fill opacity"]?.[language],
        key: "fill-opacity",
        type: "number",
        min: 0,
        max: 1,
        step: 0.01,
        step_visual: 0.2,
        is_limit: true,
      },
      {
        name: dict?.["Line color"]?.[language],
        key: "line-color",
        type: "color",
        is_limit: false,
      },
      {
        name: dict?.["Line width"]?.[language],
        key: "line-width",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        step_visual: 2,
        is_limit: false,
      },
      {
        name: dict?.["Line opacity"]?.[language],
        key: "line-opacity",
        type: "number",
        min: 0,
        max: 1,
        step: 0.01,
        step_visual: 0.2,
        is_limit: true,
      },
      {
        name: dict?.["Line gap width"]?.[language],
        key: "line-gap-width",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        step_visual: 2,
        is_limit: false,
      },
      {
        name: dict?.["Line blur"]?.[language],
        key: "line-blur",
        type: "number",
        min: 0,
        max: 10,
        step: 0.1,
        step_visual: 2,
        is_limit: false,
      },
      {
        name: dict?.["Line translate anchor"]?.[language],
        key: "line-translate-anchor",
        type: "options",
        options: [
          { name: "Map", value: "map" },
          { name: "Viewport", value: "viewport" },
        ],
        is_limit: false,
      },
    ],
  };
  const { style_type } = style_parameter;
  const array_editor = paint_properties_object?.[style_type] || [];

  return (
    <main>
      {/* 
        Injecting a style block for pseudo-elements because inline styles 
        cannot target ::-webkit-slider-thumb or ::-moz-range-thumb. 
      */}
      <style>{`
        .stick-slider {
          -webkit-appearance: none;
          appearance: none;
          width: 100%;
          background: transparent;
          margin: 0; /* Removed margin to make it compact */
          border: none; /* Strip general borders */
        }
        .stick-slider:focus {
          outline: none;
        }
        /* Chrome, Safari, Edge */
        .stick-slider::-webkit-slider-runnable-track {
          width: 100%;
          height: 2px;
          cursor: pointer;
          background: #000000;
          border: none; /* Ensure no stroke */
          outline: none;
        }
        .stick-slider::-webkit-slider-thumb {
          height: 24px;
          width: 4px; /* Makes it a stick instead of a circle */
          border-radius: 0;
          background: #000000;
          cursor: pointer;
          -webkit-appearance: none;
          margin-top: -11px; /* Align stick with the track vertically */
          border: none; /* Ensure no stroke */
        }
        /* Firefox */
        .stick-slider::-moz-range-track {
          width: 100%;
          height: 2px;
          cursor: pointer;
          background: #000000;
          border: none; /* Ensure no stroke */
          outline: none;
        }
        .stick-slider::-moz-range-thumb {
          height: 24px;
          width: 4px; /* Makes it a stick instead of a circle */
          border-radius: 0;
          background: #000000;
          cursor: pointer;
          border: none; /* Ensure no stroke */
        }
      `}</style>

      {array_editor.map((item, idx) => {
        const { name, key, type, min, max, step, step_visual, options } = item;
        let input_content;
        const value = paint_object_edited?.[key];

        if (type === "number") {
          input_content = (
            <section>
              <input
                name={key}
                value={value}
                onChange={on_change}
                min={min}
                max={max}
                step={step}
                type="range"
                data-mapid="setCircleOpacity"
                className="stick-slider" /* Use the custom pseudo-element class */
              />
              {render_scale(min, max, step_visual)}
            </section>
          );
        } else if (type === "color") {
          input_content = (
            <section>
              <div style={styles.colorInputWrapper}>
                <input
                  name={key}
                  value={value}
                  onChange={on_change}
                  type="color"
                  style={styles.colorInput}
                />
                <input
                  name={key}
                  value={value}
                  onChange={on_change}
                  type="text"
                  style={styles.textInput}
                />
              </div>
            </section>
          );
        } else if (type === "options") {
          input_content = (
            <section>
              <select
                name={key}
                value={value}
                onChange={on_change}
                style={styles.selectInput}
              >
                {options.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
            </section>
          );
        }
        return (
          <div
            key={idx}
            className="container_light background_grey_light margin_bottom"
            style={styles.container}
          >
            <p className="text_small" style={styles.textSmall}>
              {name} ({value})
            </p>
            {input_content}
          </div>
        );
      })}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  set_value_properties,
  status_action,
})(DEFAULT_STYLE_EDITOR);
